import { subCategoryIdList } from '@/api/global';
function toSnakeCase(str) {
  return String(str)
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .toLowerCase();
}

const toCamelCase = (str) => String(str).replace(/_([a-z])/g, (_, c) => c.toUpperCase());
export default function ReplaceTextFunction(key, type) {
  //   const normalizedKey = toSnakeCase(key);
  const normalizedKey = typeof value === 'number' ? key : toCamelCase(key);

  const data = {
    description: 'توضیحات',
    serial: 'سریال',
    licensePlateNumber: 'پلاك با فرمت عددي ',
    separationDate: 'تاريخ منفك شدن پلاك',
    cardPrintDate: 'تاریخ چاپ کارت',
    cardPostalBarcode: 'بارکد پستی کارت',
    cardStatusTitle: ' وضعیت کارت',
    documentPrintDate: 'تاریخ چاپ سند',
    documentPostalBarcode: 'بارکد پستی سند',
    documentStatusTitle: ' وضعیت سند',
    nationalCode: 'کد ملی',
    firstName: 'نام',
    lastName: 'نام خانوادگی',
    title: ' نوع گواهينامه',
    rahvarStatus: ' وضعيت فعلي گواهينامه در پليس راهور',
    barcode: 'بارکد',
    printNumber: 'شماره گواهينامه',
    printDate: 'تاريخ صدور',
    validYears: 'ميزان اعتبار ',
    licensePlate: 'پلاك با فرمت حروف ',
    negativePoint: 'مقدار نمره منفي',
    isDrivingAllowed: ' امكان رانندگي دارد ؟ ',
    plateHistory: 'تاریخچه پلاک',
    vehicleBrand: ' برند ',
    vehicleType: ' تيپ ',
    detachDate: 'تاريخ فك پلاك',
    vehicleModel: ' مدل ',
    plateStatus: 'وضعیت پلاک',
    attachDate: ' تاريخچه نصب پلاك',
    tracePlate: 'شماره رهگيري',
    plateChar: 'شماره پلاک',
    complaintStatus: 'شرح وضعيت شكايت',
    complaint: ' وضعيت شكايت',
    priceStatus: 'كد وضعيت قيمت',
    paperId: 'شناسه قبض',
    paymentId: ' شناسه پرداخت ',
    price: 'جمع مبلغ جرايم ',
    true: 'بلی',
    True: 'بلی',
    false: 'خیر',
    False: 'خیر',
    hasPassport: 'شخص پاسپورت دارد؟',
    hasRequest: 'درخواست پاسپورت دارد ؟',
    requestStatus: ' وضعيت درخواست',
    cardSerial: 'سریال کارت',
    documentSerial: 'سریال سند',
    status:
      type == subCategoryIdList?.travel_ban_status
        ? 'كاربر مجاز به خروج از كشور است؟'
        : 'آخرين وضعيت پاسپورت',
    requestDate: 'تاریخ درخواست',
    postBarcode: 'بارکد پستی',
    passportNo: 'شماره پاسپورت',
    expiryDate: 'تاریخ انقضا',
    isSmart: 'کارت هوشمند است؟',
    cardType: 'نوع کارت',

    cardStatus: 'وضعیت کارت',
    documentType: 'نوع سند',
    documentStatus: 'وضعیت سند',
    cardIssuanceDate: 'تاریخ صدور کارت',
    documentIssuanceDate: 'تاریخ صدور سند',
    passport: 'گذرنامه',
    plateId: 'شناسه پلاک',
    numberingPlaceDescription: '  مركز تعويض پلاک',
    numberingPlaceCode: ' كد مركز تعويض پلاک',
    // pilgrimage: '',
    1: type == subCategoryIdList?.vehicle_card_and_document_status ? 'چاپ شده' : 1,
    2: type == subCategoryIdList?.vehicle_card_and_document_status ? 'چاپ نشده' : 2,
  };

  // return data[key] !== undefined ? data[key] : key;
  //   return data[normalizedKey] !== undefined ? data[normalizedKey] : key;
  //   console.log('normalizedKey========', normalizedKey, key, type, data[1], data[key]);
  return data[normalizedKey] ?? data[key] ?? key;
}
